<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="view mtb80">
                    <div class="form_box">
                        <div class="input_wrap top">
                            <div class="inp_row">
                                <div class="inp_box">
                                    <label for="title">제목</label>
                                    <input type="text" id="title" name="title" v-model="form.title" placeholder="제목을 입력하세요">
                                </div>
                            </div>

                            <div class="upload">
                                <label for="name">이미지 업로드</label>
                                <p>고장 의심 부위 사진을 업로드 해주세요. 업로드 해주시면 빠른 매칭이 가능합니다.</p>    
                                <div class="up_area"
                                    @dragover.prevent
                                    @drop.prevent="onDrop"
                                    @click="triggerFile">
                                    <img src="@/assets/imgfile.svg">
                                    <span>{{ fileName || '이미지를 드래그해서 드롭해주세요.' }}</span>
                                </div>
                                <span>사진이 불명확할 시, 업체 매칭이 지연될 우려가 있습니다.</span>
                                <!--button type="button">등록 취소</button-->
                                <input
                                    type="file"
                                    ref="fileInput"
                                    hidden
                                    accept="image/*"
                                    @change="onFileChange"
                                />
                            </div>
                        </div>                      
                        <hr>
                        <div class="input_wrap">
                            <div class="inp_row disa">
                                <div class="inp_box">
                                    <label for="name">이름</label>
                                    <input type="text" v-model="form.name" id="name" name="name" placeholder="" disabled>
                                </div>
                                <div class="inp_box">
                                    <label for="company">회사</label>
                                    <input type="text" v-model="form.company" id="company" name="company" placeholder="회사명" disabled>
                                </div>
                                <div class="inp_box">
                                    <label for="hp">연락처</label>
                                    <input type="text" v-model="form.hp" id="hp" name="hp" placeholder="010-1234-1234" disabled>
                                </div>
                            </div>
                            <div class="inp_row">
                                <div class="inp_box">
                                    <label for="location">해당 지역(위치)</label>
                                    <input type="text" v-model="form.location" id="location" name="location" placeholder="">
                                </div>
                                <div class="inp_box">
                                    <label for="repair_date">수리/검사 희망 날짜</label>
                                    <input type="date" v-model="form.repair_date" id="repair_date" name="repair_date" placeholder="2005-12-12">
                                </div>
                                <div class="inp_box">
                                    <label for="timezone">방문 시간대</label>
                                    <input type="text" v-model="form.timezone" id="timezone" name="timezone" placeholder="ex)AM:10:00">
                                </div>
                            </div>
                            <div class="inp_box">
                                <label for="content">내용</label>
                                <textarea name="content" v-model="form.content" id="content" placeholder="해당 문의의 상세 설명을 작성해 주세요."></textarea>
                                <span>쵀대 1000자 이내로 작성해주세요.</span>
                            </div>
                        </div>
                        
                        <div class="row">
                            <!--div class="steps">
                                <div class="step active">
                                    <span class="icon chk"></span>
                                    <span class="text">문의 등록</span>
                                </div>
                                <div class="step">
                                    <span class="icon chk"></span>
                                    <span class="text">문의 확인</span>
                                </div>
                                <div class="step">
                                    <span class="icon chk"></span>
                                    <span class="text">업체 매칭</span>
                                </div>
                                <div class="step">
                                    <span class="icon non"></span>
                                    <span class="text">수리/검사</span>
                                </div>
                                <div class="step">
                                    <span class="icon non"></span>
                                    <span class="text">완료</span>
                                </div>
                            </div-->
                            <div class="btns">
                                <button class="buttn cancel" type="button" @click="goBack">취소하기</button>
                                <button class="buttn" type="button" @click="submit">등록하기</button>
                            </div>
                        </div>
                    </div>
                    <div class="btns">
                        <button class="buttn" type="button" onclick="window.location.href='/maintenance';">목록으로</button>
                    </div>
                    
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import api from '@/api'

export default {
    name: 'MaintenanceWrite',
    components: { TheHeader, TheFooter },

    data() {
        return {
            apiBaseUrl: api.defaults.baseURL,

            MAX_FILE_SIZE: 2 * 1024 * 1024,

            file: null,
            fileName: '',

            form: {
                title: '',
                name: '',
                company: '',
                hp: '',
                location: '',
                repair_date: '',
                timezone: '',
                content: ''
            }
        }
    },

    async mounted() {
        await this.checkLoginAndSetUser()
    },

    methods: {
        validateFile(file) {
            if (!file) return false

            if (file.size > this.MAX_FILE_SIZE) {
                alert('이미지는 2MB 이하 파일만 업로드 가능합니다.')
                return false
            }

            return true
        },
        /* 로그인 체크 + 회원정보 세팅 */
        async checkLoginAndSetUser() {
            try {
                const res = await api.get('/admin/user-info', {
                    withCredentials: true
                })

                if (!res.data.loggedIn) {
                    this.redirectLogin()
                    return
                }

                const user = res.data.user

                // 회원정보 자동 세팅
                this.form.name = user.name || ''
                this.form.company = user.company || ''
                this.form.hp = user.hp || ''

            } catch (e) {
                this.redirectLogin()
            }
        },

        redirectLogin() {
            const referer = this.$route.fullPath
            window.location.href =
                `/login_form?referer=${encodeURIComponent(referer)}`
        },

        goBack() {
            this.$router.back()
        },

        triggerFile() {
            this.$refs.fileInput.click()
        },

        onFileChange(e) {
            this.file = e.target.files[0]
            this.fileName = this.file ? this.file.name : ''
        },

        onDrop(e) {
            this.file = e.dataTransfer.files[0]
            this.fileName = this.file ? this.file.name : ''
        },

        /* 입력값 검증 */
        validateForm() {
            const requiredFields = {
                title: '제목',
                name: '이름',
                hp: '연락처',
                location: '지역',
                repair_date: '희망 날짜',
                timezone: '방문 시간대',
                content: '내용'
            }

            for (const key in requiredFields) {
                if (!this.form[key] || !this.form[key].toString().trim()) {
                    alert(`${requiredFields[key]}을(를) 입력해주세요.`)
                    return false
                }
            }

            return true
        },

        async submit() {
            if (!this.validateForm()) return

            const formData = new FormData()

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key])
            })

            if (this.file) {
                formData.append('image', this.file)
            }

            try {
                await api.post(
                    '/admin/maintenence_store',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        withCredentials: true
                    }
                )

                alert('등록되었습니다.')
                this.$router.push('/maintenance')

            } catch (e) {
                console.error(e)
                alert('등록 중 오류가 발생했습니다.')
            }
        }
    }
}
</script>